import DefaultHeader from '@/components/App/Header/DefaultHeader';
import React from 'react';

type Props = {};

export default function Page401() {
  return (
    <>
      <DefaultHeader isSticky />
      <div className="header-margin" />
      <div>
        <div className="container">
          <div className="row y-gap-30 justify-between items-center">
            <div className="col-12">
              <div className="no-page" style={{ maxWidth: 600, margin: '100px auto' }}>
                <div className="no-page__title">
                  40<span className="text-blue-1">1</span>
                </div>
                <h2 className="text-30 fw-600">Oops! It looks like you're not permission to access this page.</h2>
                <div className="d-inline-block mt-40 md:mt-20">
                  <a className="button -md -dark-1 bg-blue-1 text-white" href="/">
                    Go back to homepage
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
